import React from "react";
import styled from "styled-components";
import cross from "components/assets/cross.svg";
import { BoxSpinner } from "components/generic/kit";

export default ({ objectives, main_objective, deleteApi, deleteObjective }) => (
  <Wrap className="pv3-ns pa3 ph4-ns bg-white br2 mb3">
    {deleteApi.isFetching ? (
      <BoxSpinner />
    ) : (
      <React.Fragment>
        <div className="pb2 mb2 b--black-20" style={{ fontSize: "16px" }}>
          Objectives
        </div>
        {main_objective && <div className="mb1">{main_objective.label}</div>}
        <div className="flex flex-column">
          {objectives &&
            objectives.map(item => (
              <div key={item.id} className="flex justify-between mb2">
                <div>{item.label}</div>
                <div className="flex">
                  +${item.price}
                  <IconWrap
                    onClick={() => deleteObjective({ ...item })}
                    className="pl3 center pv1 pointer"
                  >
                    <img src={cross} alt="cross" height="25px" />
                  </IconWrap>
                  <div />
                </div>
              </div>
            ))}
        </div>
      </React.Fragment>
    )}
  </Wrap>
);

const Wrap = styled.div`
  background-color: #ebe8e1;
  border-top: 8px solid #000000;
  font-family: CircularStd-Book, sans-serif;
  color: #333333;
  font-size: 21px;
  @media (max-width: 680px) {
    display: none;
  }
`;
const IconWrap = styled.div`
  height: 25px;
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/components/Objectives/View.js